import { combineReducers } from "redux";
import commonReducer from "./commonReducers";

export default combineReducers({
  commonReducer,
});
